import React from "react";

import Wrapper from "./CheckoutForm";

const Checkout = (props) => {
  return <Wrapper />;
};

export default Checkout;
